import React, { useEffect, useState, useCallback } from "react";
import axios from "axios";
import "./HomePlant.css";

function HomePlant({ setTree }) {
  const [speciesList, setSpeciesList] = useState([]); // /speciesIdList
  const [currentIndex, setCurrentIndex] = useState(0); // index in speciesList
  const [currentSpecies, setCurrentSpecies] = useState(null); // speciesDetails
  const [fadeOut, setFadeOut] = useState(false);
  const [lang, setLang] = useState(localStorage.getItem("lang") || "en");

  // Fetch species list
  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_URL}/speciesIdList`)
      .then((res) => setSpeciesList(res.data.data))
      .catch((err) => console.error("Error fetching species list:", err));
  }, []);

  // Fetch species details
  const fetchSpeciesDetails = useCallback(
    async (index) => {
      if (!speciesList[index]) return;
      const speciesId = speciesList[index].id;
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_API_URL}/speciesDetails/${speciesId}`
        );
        setCurrentSpecies(res.data.data);
      } catch (err) {
        console.error("Error fetching species details:", err);
      }
    },
    [speciesList]
  );

  // Update species when index changes
  useEffect(() => {
    fetchSpeciesDetails(currentIndex);
  }, [currentIndex, fetchSpeciesDetails]);

  // Auto-traverse
  useEffect(() => {
    const interval = setInterval(() => {
      setFadeOut(true);
      setTimeout(() => {
        setCurrentIndex((prev) =>
          speciesList.length ? (prev + 1) % speciesList.length : prev
        );
        setFadeOut(false);
      }, 500);
    }, 5000);

    return () => clearInterval(interval);
  }, [speciesList]);

  if (!currentSpecies) return <div>Loading...</div>;

  // Backend image URLs (from API)
  const mainImage = currentSpecies.images?.[0]; // first image
  const thumbnails = currentSpecies.images?.slice(1, 4) || []; // next 3 images

  const handleThumbnailClick = (imgPath) => {
    setCurrentSpecies((prev) => ({ ...prev, mainImage: imgPath }));
  };

  const handleReadMore = () => {
    setTree(currentSpecies.id);
    window.location.href = "/tree";
  };

  const truncateDescription = (desc) => {
    if (!desc) return "";
    return desc.length > 300 ? desc.substring(0, 300) + "..." : desc;
  };

  return (
    <div className="home-plant">
      <div className={`fade-container ${fadeOut ? "fade-out" : ""}`}>
        <div className="top-container">
          <img
            src={currentSpecies.mainImage || mainImage}
            alt={currentSpecies.name_en}
            className="main-image"
            loading="lazy"
          />
          <div className="top-right">
            <div className="top-title">
              <i>
                {currentSpecies.name_en} || {currentSpecies.name_bn}
              </i>
            </div>
            <div
              className={`top-description ${
                lang === "bn" ? "bangla-font" : ""
              }`}
            >
              {lang === "bn"
                ? truncateDescription(currentSpecies.description_bn)
                : truncateDescription(currentSpecies.description)}
            </div>
            <div className="navigation-buttons">
              <button
                className="back-btn"
                onClick={() =>
                  setCurrentIndex(
                    (prev) =>
                      (prev - 1 + speciesList.length) % speciesList.length
                  )
                }
              >
                {"<"}
              </button>
              <button onClick={handleReadMore} className="top-btn">
                Read More about the species
              </button>
              <button
                className="back-btn"
                onClick={() =>
                  setCurrentIndex((prev) => (prev + 1) % speciesList.length)
                }
              >
                {">"}
              </button>
            </div>
            <div className="ext-img-container">
              {thumbnails.map((thumb, i) => (
                <img
                  key={i}
                  className="ext-img"
                  src={thumb}
                  alt={`Thumbnail ${i + 1}`}
                  loading="lazy"
                  onClick={() => handleThumbnailClick(thumb)}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default HomePlant;
